module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "elements"
    }
  }, [(_vm.configurator === 'k1') ? _c('k1') : _vm._e(), _vm._v(" "), (_vm.configurator === 'k1_wall') ? _c('k1wall') : _vm._e(), _vm._v(" "), (_vm.configurator === 'k2') ? _c('k2') : _vm._e(), _vm._v(" "), (_vm.configurator === 'krossing') ? _c('krossing') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-543fe440"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/views/Elements.vue
// module id = 635
// module chunks = 0